import React from "react";
import Lightbox from 'react-image-lightbox';
import { Pics, Thumbnails } from "./works";
import { Seo } from "../seo/Seo";
import 'react-image-lightbox/style.css';
import './Photos.css';

export interface IPhotosProps { }

export interface IPhotosState {
  currentImage: number;
  lightboxIsOpen: Boolean;
}

export class Photos extends React.Component<IPhotosProps, IPhotosState> {
  constructor(props: IPhotosProps) {
    super(props);
    this.state = {
      currentImage: 0,
      lightboxIsOpen: false
    };

    this.closeLightbox = this.closeLightbox.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
  }

  public render() {
    return (
      <div>
        <Seo
          title="Photos — Valere Kissi | Photographer in Sioux Falls, SD"
          description="Photography portfolio of Valere Kissi, photographer based in Sioux Falls, South Dakota."
          path="/photos"
        />
        <div className="photos-container">
          <div className="photos-grid">
            {Thumbnails.map((photo, index) => (
              <button
                className="photo-thumbnail"
                key={photo.key}
                type="button"
                onClick={() => this.openLightbox(index)}
                aria-label={`Open photo ${index + 1}`}
              >
                <img src={photo.src} alt="" loading="lazy" />
              </button>
            ))}
          </div>
          {this.state.lightboxIsOpen && <Lightbox
            onCloseRequest={this.closeLightbox}
            onMovePrevRequest={this.gotoPrevious}
            onMoveNextRequest={this.gotoNext}
            mainSrc={Pics[this.state.currentImage].src}
            nextSrc={Pics[this.state.currentImage].src}
            prevSrc={Pics[this.state.currentImage].src}
          />}
        </div>
      </div> 
    );
  };

  private openLightbox = (index: number) => {
    this.setState({
      currentImage: index,
      lightboxIsOpen: true
    });
  }

  private closeLightbox = () => {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false
    });
  }

  private gotoPrevious = () => {
    this.setState({
      currentImage: this.state.currentImage === 0 ? Pics.length - 1 : this.state.currentImage - 1
    });
  }

  private gotoNext = () => {
    this.setState({
      currentImage: this.state.currentImage === Pics.length - 1 ? 0 : this.state.currentImage + 1
    });
  }
}
